import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import firebase from '../helpers/firebase';
import _ from 'lodash';
import moment from 'moment';
import { TABLE_NAME, TIMEOFF_STATUS } from '../helpers/constants';
import NoteModal from './NoteModal.js';
import TimeOffRow from './TimeOffRow';
import { connect } from 'react-redux';

const db = firebase.database();

class TimeOffTables extends Component {

  constructor(props) {
    super(props);

    this.state = {
      pastTimeOffs: [],
      upcomingTimeOffs: [],
      showNoteModal: false
    }

    this.getTimeOffHistory = this.getTimeOffHistory.bind(this);
    this.onReviewClick = this.onReviewClick.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.approve = this.approve.bind(this);
    this.reject = this.reject.bind(this);
  }

  componentDidMount() {
    this.getTimeOffHistory();
  }

  getTimeOffHistory() {
    let ref = db.ref(TABLE_NAME.TIMEOFFS);

    if (this.props.userId) {
      ref = ref.orderByChild('userId').equalTo(this.props.userId);
    }

    ref.on('value', (snapshots) => {

      let pastTimeOffs = [];
      let upcomingTimeOffs = [];

      const { userFilter } = this.props
      snapshots.forEach((snapshot) => {
        const t = Object.assign({id: snapshot.key}, snapshot.val());

        if (userFilter && !(userFilter.indexOf(t.userId) >= 0)) {
          return
        }

        if (moment(t.startDate) < moment().startOf('day')) {
          pastTimeOffs.push(t);
        } else {
          upcomingTimeOffs.push(t);
        }
      })
      this.setState({
        pastTimeOffs: _.sortBy(pastTimeOffs, 'startDate').reverse(),
        upcomingTimeOffs: _.sortBy(upcomingTimeOffs, 'startDate'),
      });
    });
  }

  onModalClose() {
    this.setState({showNoteModal: false});
  }

  approve(note) {
    this.onModalClose();
    const statusDate = moment().format('YYYY-MM-DD');
    const modifiedBy = this.props.user;
    db.ref(TABLE_NAME.TIMEOFFS).child(this.state.currentClickedTimeoff.id).update({
      status: TIMEOFF_STATUS.APPROVED,
      statusDate,
      modifiedBy,
      note
    }).then(() => {
      // update handled in getTimeOffHistory
    })
  }

  reject(note) {
    this.onModalClose();
    const statusDate = moment().format('YYYY-MM-DD');
    const modifiedBy = this.props.user;
    db.ref(TABLE_NAME.TIMEOFFS).child(this.state.currentClickedTimeoff.id).update({
      status: TIMEOFF_STATUS.REJECTED,
      statusDate,
      modifiedBy,
      note
    }).then(() => {
      // update handled in getTimeOffHistory
    })
  }

  onReviewClick(timeoff) {
    this.setState({showNoteModal: true, currentClickedTimeoff: timeoff});
  }

  render() {
    const past = this.state.pastTimeOffs.map((t) => {
      return (<TimeOffRow key={t.id} timeoff={t} admin={this.props.admin} review={this.onReviewClick}/>)
    });

    const upcoming = this.state.upcomingTimeOffs.map((t) => {
      return (<TimeOffRow key={t.id} timeoff={t} admin={this.props.admin} review={this.onReviewClick}/>)
    });

    return <div>
      <NoteModal
        show={this.state.showNoteModal}
        onClose={this.onModalClose}
        timeoff={this.state.currentClickedTimeoff}
        approve={this.approve}
        reject={this.reject}
      />
      <h2>Upcoming Time Off Events</h2>
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            <th>Type</th>
            {this.props.admin ? <th>Applicant</th> : null}
            <th>Covering</th>
            <th>Start date</th>
            <th>Return date</th>
            <th>Days</th>
            <th>Date requested</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {upcoming}
        </tbody>
      </Table>

      <h2>Time Off History</h2>
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            <th>Type</th>
            {this.props.admin ? <th>Applicant</th> : null}
            <th>Covering</th>
            <th>Start date</th>
            <th>Return date</th>
            <th>Days</th>
            <th>Date requested</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {past}
        </tbody>
      </Table>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(TimeOffTables);



// WEBPACK FOOTER //
// ./src/components/TimeOffTables.js